import Sentry from "@similarweb/sentry-logger";

import type IntentSignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/intent/IntentSignalFilters";
import createIntentUISignalNameBuilder from "app/pages/sales-intelligence/sub-modules/signals/services/ui-signals/intent/intentUISignalNameBuilder";

import type UISignal from "../../../models/view/UISignal";
import type UISignalDeps from "../../../models/view/UISignalDeps";
import type UISignalFactory from "../UISignalFactory";

const intentUISignalFactory: UISignalFactory<IntentSignalFilters> = {
    createUISignal(deps: Readonly<UISignalDeps<IntentSignalFilters>>): Readonly<UISignal<IntentSignalFilters>> {
        const { numberOfAccounts, signal, template, intentSignalSelectedTopics, intentUserCountries } = deps;
        const { alias, description, name, signalSubType } = template;

        const nameBuilder = createIntentUISignalNameBuilder({
            intentUserCountries,
            intentSignalSelectedTopics,
        });

        return {
            ...signal,
            numberOfAccounts,
            signalSubType,
            get name() {
                try {
                    return nameBuilder.buildName(signal, template);
                } catch (e) {
                    Sentry.error(e.message, e);

                    return name;
                }
            },
            get nameSegments() {
                return nameBuilder.buildNameSegments(signal);
            },
            template: { alias, description, name },
            selectionTooltipLabels: nameBuilder.buildSelectionTooltipLabels(signal),
        };
    },
};

export default intentUISignalFactory;
